import React from "react";

const Reviews = () => {
  return (
    <div>
      <h1>Reviews Page</h1>
      <p>Read reviews from users about stores and services.</p>
    </div>
  );
};

export default Reviews;
